/**
 * Miss row for the vocabulary deck.
 *
 * The shared row already fits — one German word, one English gloss, both
 * stored in the columns it reads. The only difference is the verb: these
 * answers are tapped, not typed.
 */
import { SharedMissRow } from '@/components/practice/SharedMissRow';
import type { VokabelnPayload } from '@/core/types';

import type { MissRowProps } from '../types';

export function MissRow(props: MissRowProps<VokabelnPayload>) {
  return <SharedMissRow {...props} verb="chose" />;
}
